// extracted by mini-css-extract-plugin
export default {"NavigationPane":"Navigation_NavigationPane__YRiVo","NavigationMargin":"Navigation_NavigationMargin__LKTOA","RouteIndent":"Navigation_RouteIndent__rDPI3"};